let membersList = [];

export const setFamilyMembersList = (payload) => {
  membersList = payload;
};
export const getFamilyMembersList = () => {
  return membersList;
};

export const addNewFamilyMember = (payload) => {
  membersList.push(payload);
};

export const deleteFamilyMember = (node) => {
  for (let i = 0; i < membersList.length; i++) {
    let element = membersList[i];
    if (element.fid === node.id) {
      delete element.fid;
    }
    if (element.mid === node.id) {
      delete element.mid;
    }
    if (element?.pids?.includes(node.id)) {
      element.pids = element.pids?.filter((item) => item !== node.id);
    }
    if (element?.divorced?.includes(node.id)) {
      element.divorced = element.divorced?.filter((item) => item !== node.id);
    }
  }
  membersList = membersList.filter((item) => item.id !== node.id);
};

export const updateFamilyMember = (payload) => {
  let { type, newObj, currentNodeId } = payload;
  let nodes = membersList;
  let rootNode;
  for (let i = 0; i < nodes.length; i++) {
    const element = nodes[i];
    if (element.id === currentNodeId) {
      rootNode = element;
    }
  }
  if (type === "addpartner") {
    for (let i = 0; i < nodes.length; i++) {
      const element = nodes[i];
      if (rootNode.id === element.id) {
        if (element.pids?.length > 0) {
          element.pids = [...element?.pids, newObj.id];
        } else {
          element.pids = [newObj.id];
        }
        if (newObj.relationship?.includes("Ex")) {
          if (element.divorced?.length > 0) {
            element.divorced = [...element?.divorced, newObj.id];
          } else {
            element.divorced = [newObj.id];
          }
        }
      }
    }
  } else if (type === "addparent") {
    if (newObj.gender === "female" || newObj.gender === "other") {
      rootNode.mid = newObj.id;

      for (let i = 0; i < rootNode?.sids?.length; i++) {
        const outerElement = rootNode?.sids[i];
        for (let j = 0; j < nodes?.length; j++) {
          const innerElement = nodes[j];
          if (outerElement === innerElement.id) {
            innerElement.mid = newObj.id;
          }
        }
      }

      let father;
      if (rootNode.fid) {
        for (let i = 0; i < nodes.length; i++) {
          const element = nodes[i];
          // if (
          //   element.relationship === "Brother" ||
          //   element.relationship === "Sister"
          // ) {
          //   element.mid = newObj.id;
          //   element.fid = rootNode.fid;
          // }
          if (element.id === rootNode.fid) {
            father = element;
            if (element?.pids?.length > 0) {
              element.pids = [...element?.pids, newObj.id];
            } else {
              element.pids = [newObj.id];
            }
          }
          if (element.id === newObj.id) {
            if (element?.pids?.length > 0) {
              element.pids = [...element?.pids, father.id];
            } else {
              element.pids = [father.id];
            }
          }
        }
      }
    } else {
      rootNode.fid = newObj.id;
      for (let i = 0; i < rootNode?.sids?.length; i++) {
        const outerElement = rootNode?.sids[i];
        for (let j = 0; j < nodes?.length; j++) {
          const innerElement = nodes[j];
          if (outerElement === innerElement.id) {
            innerElement.fid = newObj.id;
          }
        }
      }

      let mother;
      if (rootNode.mid) {
        for (let i = 0; i < nodes.length; i++) {
          const element = nodes[i];
          // if (
          //   element.relationship === "Brother" ||
          //   element.relationship === "Sister"
          // ) {
          //   element.fid = newObj.id;
          //   element.mid = rootNode.mid;
          // }
          if (element.id === rootNode.mid) {
            mother = element;
            if (element?.pids?.length > 0) {
              element.pids = [...element.pids, newObj.id];
            } else {
              element.pids = [newObj.id];
            }
          }
          if (element.id === newObj.id) {
            if (element?.pids?.length > 0) {
              element.pids = [...element.pids, mother.id];
            } else {
              element.pids = [mother?.id];
            }
          }
        }
      }
    }
  } else if (type === "childrelation") {
  } else if (type === "addsiblings") {
    if (rootNode?.mid !== undefined && rootNode?.fid !== undefined) {
      for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i];
        if (element.id === newObj.id) {
          element.mid = rootNode.mid;
          element.fid = rootNode.fid;
        }
      }
      if (rootNode.sids?.length > 0) {
        rootNode.sids = [...rootNode.sids, newObj.id];
      } else {
        rootNode.sids = [newObj.id];
      }
    } else if (rootNode?.fid !== undefined) {
      for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i];

        if (rootNode.mid !== undefined) {
          element.mid = rootNode.mid;
        }
        if (element.id === newObj.id) {
          element.fid = rootNode.fid;
        }
      }
      if (rootNode.sids?.length > 0) {
        rootNode.sids = [...rootNode.sids, newObj.id];
      } else {
        rootNode.sids = [newObj.id];
      }
    } else if (rootNode?.mid !== undefined) {
      for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i];

        if (rootNode.mid !== undefined) {
          element.mid = rootNode.mid;
        }
        if (element.id === newObj.id) {
          element.mid = rootNode.mid;
        }
      }
      if (rootNode.sids?.length > 0) {
        rootNode.sids = [...rootNode.sids, newObj.id];
      } else {
        rootNode.sids = [newObj.id];
      }
    } else {
      if (rootNode.sids?.length > 0) {
        rootNode.sids = [...rootNode.sids, newObj.id];
      } else {
        rootNode.sids = [newObj.id];
      }
    }
  }
  setFamilyMembersList(nodes);
};

export const updateFamilyMemberOnEdit = (payload) => {
  let nodes = membersList;
  let {
    nodeId,
    firstName,
    lastName,
    address,
    personPassedAway,
    personLives,
    dateOfBirth,
    complicatedRelation,
    pictureId,
    note,
    marriageContract,
    mid,
    fid,
  } = payload;
  for (let i = 0; i < nodes.length; i++) {
    let element = nodes[i];
    if (element.id === nodeId) {
      element.firstName = firstName;
      element.lastName = lastName;
      element.address = address;
      element.isDead = personPassedAway;
      element.personsLive = personLives;
      element.dateOfBirth = dateOfBirth;
      element.complicatedRelation = complicatedRelation;
      element.marriageTypeId = marriageContract?.marriageTypeId;
      element.note = note;
      if (mid) {
        element.mid = mid;
      }
      if (fid) {
        element.fid = fid;
      }
      if (pictureId) {
        element.pictureId = pictureId;
      }
      if (personPassedAway) {
        element.isAliveImage = "/assets/icons/cross.png";
      } else {
        delete element.isAliveImage;
      }
    }
  }
};
export const replaceRelationWithKeys = (value) => {
  const translations = {
    "partner-male": "Ehemann / Partner",
    "partner-female": "Ehefrau / Partnerin",
    "ex-partner-male": "Ex-Mann / Ex-Partner",
    "ex-partner-female": "Ex-Frau / Ex-Partnerin",
    "add-member-heading": "Anlage einer neuen Person",
    "root": "Das sind Sie",
    "father": "Vater",
    "mother": "Mutter",
    "brother": "Bruder",
    "sister": "Schwester",
    "son": "Sohn",
    "daughter": "Tochter",
  };
  const key = Object.keys(translations).find(
    (key) => translations[key] === value
  );

  return key || value;
};
